<template>
  <div
    v-if="length >= 150 && length < 200"
    :class="{ countWarning: length >= 150, countBad: length >= 175}"
    class="charCount"
  >
    {{ length }}/200
  </div>
  <div
    v-else-if="length >= 200"
    class="charCount countBad"
  >
    Focused test questions lead to focused insights!
  </div>
</template>

<script>
export default {
  props: ['length']
}
</script>
